import { ref } from 'vue'

export default function () {
  const isLoading = ref(false)

  function startLoading() {
    isLoading.value = true
  }

  function finishLoading() {
    isLoading.value = false
  }

  return {
    isLoading,
    startLoading,
    finishLoading,
  }
}
